/* @flow */

import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import { css } from 'glamor';
import { withTheme } from 'glamorous';
import { borderWidth } from 'polished';
import { memoize } from 'lodash/fp';
import { hover } from 'app/utils/cssUtils';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  activeStyle: Object,
  children: any,
  className: string,
  component?: React.ComponentType<*>,
  link?: string,
  onTap?: () => void
};

const defaultProps = {
  component: 'span',
  link: undefined,
  onTap: undefined
};

const makeClassName = memoize(theme =>
  css({
    alignItems: 'center',
    alignSelf: 'stretch',
    backgroundColor: theme.color.basis2,
    borderColor: theme.color.basis2,
    borderStyle: 'solid',
    ...borderWidth(3, 0),
    color: theme.color.basis5,
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.demiBold,
    justifyContent: 'center',
    padding: '0.5em',
    textTransform: 'uppercase',
    transition: 'all 0.2s',
    ...hover({
      color: theme.color.white
    })
  }).toString()
);

function NavBarItemFlat({ activeStyle, children, className, component, link, onTap }: Props) {
  if (link) {
    return (
      <Tappable
        activeStyle={activeStyle}
        className={className}
        component={NavLink}
        onTap={onTap}
        to={link}
      >
        {children}
      </Tappable>
    );
  }

  return (
    <Tappable className={className} component={component} onTap={onTap}>
      {children}
    </Tappable>
  );
}

NavBarItemFlat.defaultProps = defaultProps;

const enhancer = compose(
  withTheme,
  withProps(({ theme }) => ({
    activeStyle: {
      borderBottomColor: theme.color.primary,
      color: theme.color.white
    },
    className: makeClassName(theme)
  }))
);

export default enhancer(NavBarItemFlat);
